import styled from 'styled-components'

export const CatalogItemContentStyled = styled.div`
  flex: 1 0 0;
  min-width: 0;
  padding: ${(props) => props.theme.space.small};
`
